import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Status } from '../../../models/status';
import { AccountModuleId, LeadModuleId } from '../../../constants/modules.constant';
import { AccountsHttpService } from '../../../services/accounts.http.service';
import { UpdatedAccountAddress } from '../../../models/accounts/account-address-model';
import { AppMainService } from '../../../../../app-main.service'
import { MessageService } from 'primeng/api';
@Component({
    selector: 'app-lion-address-grid',
    templateUrl: './address-grid.component.html',
    styleUrls: ['./address-grid.component.scss']
})
export class LionAddressGridComponent implements OnChanges {

    accountAddressTypeList = [];
    showAddAddress: boolean = false;
    editAddressIndex = null;
    isAddAddress: boolean;
    addressTemp = null;
    addressNameValue = '';

    @Input() fieldLabels;
    @Input() addressList;
    @Input() header: String;
    @Input() contactListAttn = [];
    @Input() selectedObjectRecord = null;
    @Input() allowEdit: boolean = true;
    @Input() mappingField: string;
    @Input() countries = [];
    @Input() accountAddressTypes = [];
    @Input() addressClasses = [];
    @Input() moduleId;
    @Input() checkedFields;
    @Input() overViewPage: boolean = false;
    @Input() accountName: string='';
    @Input() firstName: string='';
    @Input() lastName: string='';
    @Output() onUpdateAddressList = new EventEmitter();

    accountModuleId = AccountModuleId;
    leadModuleId = LeadModuleId;

    constructor(
        private accountsHttpService: AccountsHttpService,
        public appMainService: AppMainService,
        private messageService: MessageService,
        ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.fieldLabels && changes.fieldLabels.currentValue) {
            this.currentLabels = changes.fieldLabels.currentValue
        }

        if (changes.addressList && changes.addressList.currentValue) {
            this.currentAddressList = JSON.parse(JSON.stringify(changes.addressList.currentValue));
            this.currentAddressList.sort(this.compare);
        }

        if (changes.contactListAttn && changes.contactListAttn.currentValue) {
            this.currentContactListAttn = changes.contactListAttn.currentValue;
        }

        if (changes.selectedObjectRecord && changes.selectedObjectRecord.currentValue) {
            this.currentSelectedObjectRecord = changes.selectedObjectRecord.currentValue;
        }

        if (changes.allowEdit && changes.allowEdit.currentValue != undefined) {
            this.currentAllowEditValue = changes.allowEdit.currentValue;
        }

        if (changes.mappingField && changes.mappingField.currentValue) {
            this.currentMappingField = changes.mappingField.currentValue;
        }

        if(changes.checkedFields && changes.checkedFields.currentValue){
            this.checkedFields = changes.checkedFields.currentValue;
        }

        if(changes.moduleId && changes.moduleId.currentValue){
            this.moduleId = changes.moduleId.currentValue;
        }

        if(changes.overViewPage && changes.overViewPage.currentValue){
            this.overViewPage = changes.overViewPage.currentValue;
        }

    }

    currentLabels = [];
    currentAddressList = [];
    currentContactListAttn = []
    currentSelectedObjectRecord = null;
    currentAllowEditValue = true;
    currentMappingField = null;

    compare (a, b) {
        if (a.address?.name < b.address?.name) {
            return -1;
        }

        if ( a.address?.name > b.address?.name) {
            return 1;
        }

        return 0;
    }

    onUpdateAddress() {
        this.currentAddressList = this.currentAddressList.filter(el => el.address.statusId !== 3);
        this.onUpdateAddressList.emit({ addressList: this.currentAddressList });
        this.showAddAddress = false;
        // this.overViewPage = false;
    }

    setStatusField(addressList) {
        addressList.map(obj => {
            if (obj.address) {
                if (obj.address.statusId == Status.Active) {
                    obj.address.statusId = true
                } else {
                    obj.address.statusId = false
                }
            }

            return obj;
        })
    }

    handleChange(addressObj) {
        let data = JSON.parse(JSON.stringify(addressObj));
        let updatedAddress = this.updateAddressModel(data);
        if(this.overViewPage){
            this.editAccountAddress(updatedAddress)
        }

        this.onUpdateAddressList.emit({ addressList: this.currentAddressList });
    }

    updateAddressModel(data:any){
        let updatedAddress: UpdatedAccountAddress = {
        accountId: data.accountId,
        addressId: data.addressId,
        address: {
            name: data.address.name,
            addressName: data.address?.addressName || "",
            streetAddress1: data.address.streetAddress1,
            streetAddress2: data.address.streetAddress2 || "",
            description: data.address.description || "",
            latitude: data.address.latitude,
            longitude: data.address.longitude,
            cityId: data.address.cityId,
            city: data.address.city,
            stateId: data.address.stateId,
            state: data.address.state,
            countryId: data.address.countryId,
            zipCode: data.address.zipCode,
            addressTypeId: data.address.addressTypeId,
            addressClassId: data.address.addressClassId,
            attnContactId: data.address.attnContactId,
            // attnContact: data.address.attnContact,
            statusId: data.address.statusId,
            isDefault: data.address.isDefault,
            id: data.address.id,
            createdSource: data.address.createdSource,
            updatedSource: data.address.updatedSource || null,
            createdBy: data.address.createdBy,
            updatedBy: data.address.updatedBy || null,
            createdDate: data.address.createdDate,
            updatedDate: data.address.updatedDate || null,
        },
        id: data.id,
        createdSource: data.createdSource,
        updatedSource: data.updatedSource || null,
        createdBy: data.createdBy,
        updatedBy: data.updatedBy || null,
        createdDate: data.createdDate,
        updatedDate: data.updatedDate || null,
     }
     return updatedAddress;
    }

    defaultHandleChange(addressObj){
        let data = JSON.parse(JSON.stringify(addressObj));
        let updatedAddress = this.updateAddressModel(data);
        if(this.overViewPage){
            this.editAccountAddress(updatedAddress);
        }
    }

    setDefaultAddr(currentAdd, currentIndex) {
        if (this.currentAddressList.length > 1) {
            const addressType = this.currentAddressList[currentIndex].address.addressType;
            this.currentAddressList.forEach((addressObj, index) => {
                if (index !== currentIndex && addressType.id == addressObj.address.addressType.id) {
                    addressObj.address.isDefault = false;
                }
            });
            this.currentAddressList[currentIndex].address.statusId = 1;
            this.defaultHandleChange(currentAdd);
            this.onUpdateAddressList.emit({ addressList: this.currentAddressList });
        } else {
            currentAdd.address.isDefault = true;
        }
        // this.currentAddressList[currentIndex].address.statusId = 1;
        // this.defaultHandleChange(currentAdd);
        // this.onUpdateAddressList.emit({ addressList: this.currentAddressList })
    }

    getContactName(addressObj) {
        //addressObj.address && addressObj.address.attnContact && addressObj.address.attnContact.contactName ? addressObj.address?.attnContact?.contactName : addressObj.address?.attnContact?.firstName+' '+ addressObj.address?.attnContact?.lastName
        let name = '';
        if (addressObj.address && addressObj.address.attnContact && addressObj.address.attnContact.contactName) {
            name = addressObj.address?.attnContact?.contactName;
        } else {
            const attnContact = addressObj.address?.attnContact;
            if (attnContact) {
                name = attnContact?.firstName ? attnContact?.firstName+" " : name;
                name = attnContact.middleName ? name.concat(attnContact.middleName+" ") : name;
                name = attnContact.lastName ? name.concat(attnContact.lastName) : name;
            }

        }

        return name;
    }

    cancelAddaddress($event) {
        // this.overViewPage = false;
        this.addressNameValue = '';
        this.showAddAddress = false;
    }

    onAddAddress($event) {
        const addObj = $event.address;
        if (this.editAddressIndex !== null) {
            this.currentAddressList.splice(this.editAddressIndex, 1, addObj);
        } else {
            if (addObj.address.isDefault) {
                for (let el of this.currentAddressList) {
                    if (addObj.address.addressType.name === el.address.addressType.name && el.addressId !== 0) {
                        el.address.isDefault = false;
                    }
                }

                // let count = 0;

                // for (let i = 0; i < this.currentAddressList.length - 1; i++) {
                //     if (this.currentAddressList[i].address.addressType.name === addObj.address.addressType.name) {
                //         ++count;
                //     }
                // }

                // if (count > 1) {
                //     for (let i = 0; i < this.currentAddressList.length - 1; i++) {
                //         if (this.currentAddressList[i].address.addressType.name === addObj.address.addressType.name) {
                //             this.currentAddressList[i].address.isDefault = false;
                //         }
                //     }
                // }
            }

            const addresses = this.getAddressOfUniqueType(addObj);

            if (addresses.length == 0) {
                addObj.address.isDefault = true;
                addObj.address.statusId = 1;
            }

            this.currentAddressList.push(addObj);
        }

        this.showAddAddress = false;
        // this.overViewPage = false;
        this.onUpdateAddressList.emit({ addressList: this.currentAddressList })
    }

    getAddressOfUniqueType(newAddressObj) {
        let objList = [];
        this.currentAddressList.forEach(obj => {
            if (((obj.address.status && obj.address.status.id != 3) || !obj.address.status) && obj.address.addressTypeId == newAddressObj.address.addressTypeId) {
                objList.push(obj);
            }
        });
        return objList;
    }

    getFullName(){
        const firstName = this.firstName || '';
        const lastName = this.lastName || '';
        return `${firstName} ${lastName}`.trim();
    }

    addNewAddress() {
        if (this.currentAllowEditValue) {
            this.editAddressIndex = null;
            this.showAddAddress = true;
            this.header = 'Add New Address';
            this.isAddAddress = true;
            this.addressNameValue = this.accountName ? this.accountName : this.getFullName();
            // this.overViewPage = true;
        }
    }

    async editAddress(c, editAddIndex) {
        if (this.currentAllowEditValue) {
            this.showAddAddress = true;
            this.isAddAddress = false;
            // this.overViewPage = true;
            this.editAddressIndex = editAddIndex;
            this.header = "Edit Address";
            this.addressTemp = JSON.parse(JSON.stringify(c));
            this.addressNameValue = c.address.addressName;
        }

        // this.selectedAddressType = this.accountAddressTypes.find(
        //     (ele) => ele.id == this.addressTemp.address.addressTypeId
        // );
        // this.selectedAddressCountry = this.countries.find(c => c.id == this.addressTemp.address.country.id);
        // await this.loadCountryStates();
        // this.selectedAddressState = this.addressTemp.address.state;
        // await this.loadCountryCities();
        // this.selectedAddressCity = this.addressTemp.address.city;
        // this.displayAddressAdd = true;
        // this.selectedAddressattnContact = this.contactListAttn.find((ob: any) => this.addressTemp && this.addressTemp.address.attnContactId && ob.contactId == this.addressTemp.address.attnContactId)
    }

    onDeleteAddAddress() {
        this.onUpdateAddressList.emit({ addressList: this.currentAddressList });
        this.showAddAddress = false;
    }

    // onDeleteAddAddress($event) {
    //     const addIndex = $event.index;
    //     const address = $event.addressObject.address;

    //     if (address.id == 0) {
    //         // delete newly added record
    //         this.currentAddressList.splice(addIndex, 1);
    //     } else {
    //         this.currentAddressList[addIndex].address.statusId = Status.Deleted;
    //         const oldStatus = this.currentAddressList[addIndex].address.status;
    //         this.currentAddressList[addIndex].address.status = { ...oldStatus, id: 3, name: 'Deleted' }
    //         // set default address of next t
    //         // const setDefault = this.getAddressOfUniqueType({address});
    //         // if(setDefault.length){
    //         //     setDefault[0].address.isDefault = true;
    //         //     setDefault[0].address.statusId = true;
    //         // }
    //     }

    //     this.currentAddressList = JSON.parse(JSON.stringify(this.currentAddressList));
    //     this.onUpdateAddressList.emit({ addressList: this.currentAddressList })
    //     this.showAddAddress = false;
    // }

    updateStatus(currentAddressList) {
        let addressList = JSON.parse(JSON.stringify(currentAddressList));
        addressList.forEach((addressObj) => {
            addressObj.address.statusId = (addressObj.address.status && addressObj.address.status.id == 3) ? 3 : addressObj.address.statusId == true ? 1 : addressObj.address.statusId == false ? 2 : 3;
        });

        return addressList;
    }

    editAccountAddress(data){
        this.appMainService.isShowSpinner('updateAddress');
        this.accountsHttpService.editAccountAddress(data).subscribe({
            next:(data)=>{
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Address is successfully updated...' });
                this.appMainService.isHideSpinner('updateAddress');
            },
            error: (error)=>{
                this.appMainService.isHideSpinner('updateAddress');
            },
        })
    }
}
